module.exports = __webpack_public_path__ + "img/f9bfdc1e6914e313bacebbda1dd16ce0.png";